import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Name = styled.span`
  ${(props) => props.theme.fonts.interSemibold18};
  color: ${(props) => props.theme.colors.white100};
  margin-left: .5rem;
`;

export const Flag = styled.img`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  object-fit: cover;
`;